module.exports = __webpack_public_path__ + "static/media/Wealthrix.5b745fa5.png";